import { CheckoutState } from '../../state';
import { isCustomQuestion, isRequiredQuestion } from '../../utils/surveys';
import { getQuestionsForAttendees } from './attendees';
import { getQuestionsForBuyer } from './buyer';

export const hasRequiredCustomQuestions = (state: CheckoutState) => {
    const allQuestions = [
        ...getQuestionsForAttendees(state).flatMap(({ survey }) => survey),
        ...getQuestionsForBuyer(state),
    ];

    return allQuestions.some((question) => {
        return (
            isCustomQuestion(question) &&
            isRequiredQuestion(question, allQuestions)
        );
    });
};
